(function () {
  var MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var WEEKDAYS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

  function parseDate(label) {
    var m = label.trim().match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (m) {
      return new Date(parseInt(m[3], 10), parseInt(m[2], 10) - 1, parseInt(m[1], 10));
    }
    m = label.trim().match(/(\d{1,2})\/(\d{1,2})/);
    if (!m) return null;
    var day = parseInt(m[1], 10);
    var month = parseInt(m[2], 10) - 1;
    var now = new Date();
    var year = now.getFullYear();
    var candidate = new Date(year, month, day);
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (candidate < today) candidate = new Date(year + 1, month, day);
    return candidate;
  }

  function buildCalendar(entries) {
    var byMonth = {};
    entries.forEach(function (entry) {
      var key = entry.date.getFullYear() + '-' + entry.date.getMonth();
      if (!byMonth[key]) byMonth[key] = { year: entry.date.getFullYear(), month: entry.date.getMonth(), days: {} };
      byMonth[key].days[entry.date.getDate()] = entry;
    });

    var months = Object.keys(byMonth)
      .map(function (k) { return byMonth[k]; })
      .sort(function (a, b) { return a.year - b.year || a.month - b.month; });

    var wrap = document.createElement('div');
    wrap.className = 'pp-date-picker';

    var current = 0;
    var selectedMonthIndex = months.findIndex(function (m) {
      return Object.keys(m.days).some(function (d) { return m.days[d].selected; });
    });
    if (selectedMonthIndex > -1) current = selectedMonthIndex;

    var monthEl = document.createElement('div');
    monthEl.className = 'pp-date-picker__month';

    var nav = document.createElement('div');
    nav.className = 'pp-date-picker__nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'pp-date-picker__nav-btn';
    prevBtn.setAttribute('aria-label', 'Mois précédent');
    prevBtn.textContent = '‹';

    var heading = document.createElement('p');
    heading.className = 'pp-date-picker__heading';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'pp-date-picker__nav-btn';
    nextBtn.setAttribute('aria-label', 'Mois suivant');
    nextBtn.textContent = '›';

    nav.appendChild(prevBtn);
    nav.appendChild(heading);
    nav.appendChild(nextBtn);
    monthEl.appendChild(nav);

    var weekdaysRow = document.createElement('div');
    weekdaysRow.className = 'pp-date-picker__grid pp-date-picker__grid--weekdays';
    WEEKDAYS.forEach(function (w) {
      var cell = document.createElement('span');
      cell.className = 'pp-date-picker__weekday';
      cell.textContent = w;
      weekdaysRow.appendChild(cell);
    });
    monthEl.appendChild(weekdaysRow);

    var grid = document.createElement('div');
    grid.className = 'pp-date-picker__grid';
    monthEl.appendChild(grid);
    wrap.appendChild(monthEl);

    function render() {
      var m = months[current];
      heading.textContent = MONTHS[m.month] + ' ' + m.year;
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === months.length - 1;
      grid.innerHTML = '';

      var firstOfMonth = new Date(m.year, m.month, 1);
      var startOffset = (firstOfMonth.getDay() + 6) % 7;
      var daysInMonth = new Date(m.year, m.month + 1, 0).getDate();

      for (var i = 0; i < startOffset; i++) {
        var blank = document.createElement('span');
        blank.className = 'pp-date-picker__day pp-date-picker__day--empty';
        grid.appendChild(blank);
      }

      for (var d = 1; d <= daysInMonth; d++) {
        var entry = m.days[d];
        if (entry) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pp-date-picker__day pp-date-picker__day--available';
          if (entry.disabled) btn.className += ' pp-date-picker__day--sold-out';
          if (entry.selected) btn.className += ' is-selected';
          btn.textContent = d;
          btn.disabled = entry.disabled;
          btn.setAttribute('aria-label', entry.label);
          btn.addEventListener('click', function (entry) {
            return function () {
              entry.input.checked = true;
              entry.input.dispatchEvent(new Event('change', { bubbles: true }));
              wrap.querySelectorAll('.is-selected').forEach(function (el) { el.classList.remove('is-selected'); });
              this.classList.add('is-selected');
            };
          }(entry));
          grid.appendChild(btn);
        } else {
          var day = document.createElement('span');
          day.className = 'pp-date-picker__day pp-date-picker__day--muted';
          day.textContent = d;
          grid.appendChild(day);
        }
      }
    }

    prevBtn.addEventListener('click', function () {
      if (current > 0) { current -= 1; render(); }
    });
    nextBtn.addEventListener('click', function () {
      if (current < months.length - 1) { current += 1; render(); }
    });

    render();

    return wrap;
  }

  function enhance(fieldset) {
    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    if (!inputs.length) return;

    var entries = [];
    inputs.forEach(function (input) {
      var label = fieldset.querySelector('label[for="' + input.id + '"]');
      var text = label ? label.textContent : input.value;
      var date = parseDate(text);
      if (!date) return;
      var m = text.trim().match(/(\d{1,2})\/(\d{1,2})/);
      entries.push({
        date: date,
        input: input,
        disabled: input.disabled || input.classList.contains('disabled'),
        selected: input.checked,
        label: m[0]
      });
    });

    if (!entries.length) return;

    var calendar = buildCalendar(entries);
    fieldset.classList.add('pp-date-picker__native');
    fieldset.insertAdjacentElement('afterend', calendar);
  }

  function isEnhanced(fieldset) {
    var next = fieldset.nextElementSibling;
    return fieldset.classList.contains('pp-date-picker__native') && next && next.classList.contains('pp-date-picker');
  }

  function init(root) {
    (root || document).querySelectorAll('fieldset').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend || legend.textContent.trim().toLowerCase() !== 'date') return;
      if (isEnhanced(fieldset)) return;
      var stale = fieldset.previousElementSibling;
      if (stale && stale.classList && stale.classList.contains('pp-date-picker')) stale.remove();
      var staleNext = fieldset.nextElementSibling;
      if (staleNext && staleNext.classList && staleNext.classList.contains('pp-date-picker')) staleNext.remove();
      enhance(fieldset);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Dawn swaps the variant picker for fresh server-rendered markup after each
  // selection, wiping out our injected calendar — watch for that and rebuild it.
  var observer = new MutationObserver(function () { init(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();
